import { CustomModal } from '@publicisgroupe/p-os-components';
import React from 'react';
import { Field } from '../../interfaces/Field';
import './XdmContextItemModal.less';
import { XdmContextItem } from '../XdmContextItem/XdmContextItem';

export interface XdmContextItemModalProps {
  field: Field;
  initialValues: any;
  onClose?: () => void;
  onSubmit: (newValue: any) => void;
}

export const XdmContextItemModal: React.FC<XdmContextItemModalProps> = ({
  field,
  initialValues,
  onClose,
  onSubmit,
}) => {
  return (
    <CustomModal
      data-testid="masterdatacontext-modal"
      className="xdmcontext-item-modal"
      open={true}
      onClose={onClose}
      centered
      size="large"
      header={<>Master Data Context</>}
    >
      <CustomModal.Content>
        <XdmContextItem
          field={field}
          initialValues={initialValues}
          onClose={onClose}
          onSubmit={onSubmit}
        />
      </CustomModal.Content>
    </CustomModal>
  );
};
